import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="footer-area footer-padding">
        <div className="footer-wrapper">
          <div className="container">
            <div className="row d-flex justify-content-between">
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                <div className="single-footer-caption mb-50">
                  <div className="single-footer-caption mb-30">
                    <div className="footer-logo mb-25">
                      <a href="">
                        <img
                          src={require("./../assets/logo-dark.png")}
                          height={"140px"}
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="footer-tittle">
                      <div className="footer-pera">
                        <p className="text-dark">
                          A stimulus designed to invigorate and excite great
                          minds.
                        </p>
                      </div>
                    </div>

                    <ul className="footer-social">
                      <li>
                        <a className="fb" href="https://bit.ly/sai4ull">
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a className="yt" href="#">
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a className="lnk" href="#">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a className="ins" href="#">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-5">
                <div className="single-footer-caption mb-50"></div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-8 col-sm-11">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4 className="text-dark">Contact Us</h4>
                    <ul>
                      <li>
                        <a href="#" className="text-dark">
                          Block 18, Gulistan-e-Jauhar, University Avenue، Off
                          Shahrah-e-Faisal Rd, Faisal Cantonment, Karachi,
                          Karachi City, Sindh
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-dark">
                          atomos@habib.edu.pk
                        </a>
                      </li>
                      <li className="number">
                        <a href="#" className="text-dark">
                          (021) 111 042 242
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom-area">
            <div className="container">
              <div className="footer-border">
                <div className="row d-flex align-items-center">
                  <div className="col-xl-12">
                    <div className="footer-copy-right text-center">
                      <p>
                        Copyright © {new Date().getFullYear()} All rights
                        reserved &nbsp;
                        <i
                          className="fa fa-heart color-danger"
                          aria-hidden="true"
                        ></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
